module.exports = __webpack_public_path__ + "img/goods11_5.00eb555a.jpg";